// Ô trả lời nhanh: chip mẫu câu + Ctrl/⌘+Enter để gửi
import React, { useState } from "react";
import { Input, Button, Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { getCannedReplies } from "../canned-replies";

export default function ReplyBox({ onSubmit, submitting }) {
    const [text, setText] = useState("");
    const canned = getCannedReplies();

    const send = async () => {
        const value = text.trim();
        if (!value) return;
        await onSubmit(value);
        setText("");
    };

    // Chèn mẫu câu (ghi đè nếu trống, nối thêm nếu đang gõ dở)
    const insertCanned = (tpl) =>
        setText((prev) => (prev.trim() ? `${prev.trim()} ${tpl}` : tpl));

    return (
        <div className="flex flex-col gap-2 mt-2">
            <div className="flex flex-wrap gap-1">
                {canned.map((tpl, i) => (
                    <Tag
                        key={i}
                        color="blue"
                        className="cursor-pointer"
                        onClick={() => insertCanned(tpl)}
                    >
                        {tpl.length > 36 ? `${tpl.slice(0, 36)}…` : tpl}
                    </Tag>
                ))}
            </div>
            <Input.TextArea
                rows={2}
                value={text}
                onChange={(e) => setText(e.target.value)}
                onPressEnter={(e) => {
                    if (e.ctrlKey || e.metaKey) {
                        e.preventDefault();
                        send();
                    }
                }}
                placeholder="Nhập trả lời… (Ctrl/⌘+Enter để gửi). Người được trả lời sẽ nhận thông báo."
            />
            <div className="flex justify-end">
                <Button
                    type="primary"
                    icon={<FontAwesomeIcon icon={faPaperPlane} />}
                    loading={submitting}
                    disabled={!text.trim()}
                    onClick={send}
                >
                    Gửi trả lời
                </Button>
            </div>
        </div>
    );
}
